const lessonJSON = {
    "lessons":[
    {
      "id": "ex001",
      "title": "Workout/Warm-Up: Beginner Chromatic",
      "description": "A fundamental daily exercise to improve finger dexterity and alternate picking synchronization. Perfect for a warm-up.",
      "url": "https://documents.jqguitaracademy.com/Warmup-chromatic-alternatepicking.pdf",
      "gp_url": null,
      "category": "Workouts",
      "tags": ["beginner", "warm-up", "alternate picking", "dexterity", "exercise"],
      "difficulty": "Beginner",
      "dateAdded": "2025-10-20T22:00:00Z"
    },
    {
      "id": "ex002",
      "title": "Workout/Warm-Up: Advanced Chromatic",
      "description": "A more advanced daily exercise to further improve finger dexterity, speed, accuracy and alternate picking synchronization. Also a good exercise for that pre-gig warm-up",
      "url": "https://documents.jqguitaracademy.com/Warmup-chromatic-alternatepicking-advanced.pdf",
      "gp_url": null,
      "category": "Workouts",
      "tags": ["intermediate", "warm-up", "alternate picking", "dexterity", "exercise"],
      "difficulty": "Intermediate",
      "dateAdded": "2025-10-20T22:00:00Z"
    },
    {
      "id": "th001",
      "title": "Introduction to Harmonized Triads",
      "description": "Understand multiple concepts with one simple exercise. Utilize major, minor and diminished triads, and a simple progression to tie the entire fretboard together.",
      "url": "https://documents.jqguitaracademy.com/harmonized-c-maj-triad-positions.pdf",
      "gp_url": null,
      "category": "Theory",
      "tags": ["intermediate", "harmony", "chords", "triads", "major", "minor", "diminished"],
      "difficulty": "Intermediate",
      "dateAdded": "2025-10-20T15:30:00Z"
    },
    {
      "id": "ex003",
      "title": "Exercise: Precise String Bending",
      "description": "An exercise created by Paul Gilbert focuses on developing pitch control and accuracy when bending strings.",
      "url": "https://documents.jqguitaracademy.com/Bending%20Exercise%202.pdf",
      "gp_url": "https://documents.jqguitaracademy.com/Bending%20Notes%20-%20Exercise.gp",
      "category": "Technique",
      "tags": ["beginner", "bending", "phrasing", "pitch", "exercise"],
      "difficulty": "Beginner",
      "dateAdded": "2025-10-20T11:00:00Z"
    },
    {
      "id": "sg001",
      "title": "100 Guitar Riffs!",
      "description": "Pick up dozens of simple, but effective techniques through learning some world-famous riffs",
      "url": "https://documents.jqguitaracademy.com/100-Guitar-Riffs.pdf",
      "gp_url": null,
      "category": "Songs",
      "tags": ["beginner", "intermediate", "riffs", "songs", "techniques"],
      "difficulty": "Beginner",
      "dateAdded": "2025-10-20T11:00:00Z"
    },
    {
      "id": "ex004",
      "title": "Exercise: Advanced Alternate Picking - Major Scale",
      "description": "Take alternate picking to the next level with this more advanced exercise.",
      "url": "https://documents.jqguitaracademy.com/advanced-alternate-picking-major-scale.pdf",
      "gp_url": "https://documents.jqguitaracademy.com/Advanced%20Alternate%20Picking%20-%20Major%20Scale.gp",
      "category": "Technique",
      "tags": ["intermediate", "warm-up", "alternate picking", "dexterity", "exercise"],
      "difficulty": "Intermediate",
      "dateAdded": "2025-10-20T11:00:00Z"
    },
    {
      "id": "th002",
      "title": "CAGED: Major Triads",
      "description": "CAGED is a fundamental system which breaks the fretboard in to interconnected boxes. This exercise explores the major scale within the C, A, G, E, and D positions",
      "url": "https://documents.jqguitaracademy.com/CAGED%20Major%20Triads.pdf",
      "gp_url": "https://documents.jqguitaracademy.com/CAGED%20Major%20Triads.gp",
      "category": "Theory",
      "tags": ["intermediate", "CAGED", "major", "triad"],
      "difficulty": "Intermediate",
      "dateAdded": "2025-10-20T11:00:00Z"
    },
    {
      "id": "th003",
      "title": "CAGED: Minor Triads",
      "description": "CAGED is a fundamental system which breaks the fretboard in to interconnected boxes. This exercise explores the minor scale within the C, A, G, E, and D positions",
      "url": "https://documents.jqguitaracademy.com/CAGED%20Minor%20Triads.pdf",
      "gp_url": "https://documents.jqguitaracademy.com/CAGED%20Minor%20Triads.gp",
      "category": "Theory",
      "tags": ["intermediate", "CAGED", "minor", "triad"],
      "difficulty": "Intermediate",
      "dateAdded": "2025-10-20T11:00:00Z"
    },
    {
      "id": "th004",
      "title": "CAGED: Fretboard Diagram",
      "description": "CAGED is a fundamental system which breaks the fretboard in to interconnected boxes. This is a diagram of the fretboard showing how all 5 shapes work together",
      "url": "https://documents.jqguitaracademy.com/CAGED-Fretboard.jpg",
      "gp_url": null,
      "category": "Theory",
      "tags": ["intermediate", "CAGED", "diagram", "image"],
      "difficulty": "Intermediate",
      "dateAdded": "2025-10-20T11:00:00Z"
    },
    {
      "id": "ex004",
      "title": "Exercise: Timed Training",
      "description": "Three timed exercises which if done daily will build stamina, speed and accuracy!",
      "url": "https://documents.jqguitaracademy.com/three-training-exercises-guitar.pdf",
      "gp_url": "https://documents.jqguitaracademy.com/3%20Training%20Exercises%20for%20Guitar.gp",
      "category": "Workouts",
      "tags": ["intermediate", "training", "exercise", "dexterity", "stamina", "speed", "accuracy", "legato", "scales"],
      "difficulty": "Intermediate",
      "dateAdded": "2025-10-20T11:00:00Z"
    },
    {
      "id": "th005",
      "title": "Introduction to Time Signatures and Note Lengths",
      "description": "Song-driven lesson introducing time signatures, and note lengths.",
      "url": "https://documents.jqguitaracademy.com/Understanding%20Time%20Signatures%20&%20Note%20Lengths.pdf",
      "gp_url": "https://documents.jqguitaracademy.com/Understanding%20Time%20Signatures%20&%20Note%20Lengths.gp",
      "category": "Theory",
      "tags": ["beginner", "notation", "reading"],
      "difficulty": "Beginner",
      "dateAdded": "2025-10-20T11:00:00Z"
    },
    {
      "id": "th006",
      "title": "Note Length - Cheatsheet",
      "description": "A cheatsheet of note lengths and how to read them.",
      "url": "https://documents.jqguitaracademy.com/Understanding%20Time%20Signatures%20&%20Note%20Lengths-P2.pdf",
      "gp_url": null,
      "category": "Theory",
      "tags": ["beginner", "notation", "reading"],
      "difficulty": "Beginner",
      "dateAdded": "2025-10-20T11:00:00Z"
    },
    {
      "id": "ex005",
      "title": "Exercise: Economy Picking",
      "description": "An exercise introducing economy picking.",
      "url": "https://documents.jqguitaracademy.com/economypicking.pdf",
      "gp_url": "https://documents.jqguitaracademy.com/economy%20picking.gp",
      "category": "Technique",
      "tags": ["beginner", "economy picking", "warm-up", "dexterity", "exercise"],
      "difficulty": "Beginner",
      "dateAdded": "2025-10-20T11:00:00Z"
    },
    {
      "id": "ex006",
      "title": "Exercise: Introducing Legato",
      "description": "An exercise introducing Legato.",
      "url": "https://documents.jqguitaracademy.com/legatoexercises.pdf",
      "gp_url": "https://documents.jqguitaracademy.com/legato%20exercises.gp",
      "category": "Technique",
      "tags": ["beginner", "legato", "warm-up", "dexterity", "exercise"],
      "difficulty": "Beginner",
      "dateAdded": "2025-10-20T11:00:00Z"
    }

    
]
}
export default lessonJSON;

/*  


https://documents.jqguitaracademy.com/Alternate%20Picking%20Exercise%20-%20advanced.gp
https://documents.jqguitaracademy.com/Alternate%20Picking%20Exercise.gp
https://documents.jqguitaracademy.com/B%20Minor%20Scale.gp
https://documents.jqguitaracademy.com/B%20Minor%20Scales.gp
https://documents.jqguitaracademy.com/Bminor-scales.pdf

https://documents.jqguitaracademy.com/Etude%2002.gp
https://documents.jqguitaracademy.com/Ex.%201%20-%20Arpeggio%20Chord%20Progression%20in%20Key%20of%20G.pdf
https://documents.jqguitaracademy.com/First%20scales%20-%20Major.gp
https://documents.jqguitaracademy.com/G%20Minor%20Scale.gp
https://documents.jqguitaracademy.com/Gminor-scale.pdf
https://documents.jqguitaracademy.com/Harmonized%20C%20Major%20-%20D%20Position.gp
https://documents.jqguitaracademy.com/Legato%20Exercise%20-%20CL1.gp
https://documents.jqguitaracademy.com/Lessons%20-%20Scales%20-%20Caged%20Exercise%201%20-%20Chord%20Progression%20I-V-Vi-Iv%20In%20Key%20Of%20G.gp5
https://documents.jqguitaracademy.com/Lessons%20-%20Scales%20-%20Caged%20Exercise%201%20-%20Chord%20Progression%20I-V-Vi-Iv%20In%20Key%20Of%20G.gp
https://documents.jqguitaracademy.com/Lessons%20-%20Scales%20-%20Caged%20Exercise%202%20-%20Chord%20Progression%20I-V-Vi-Iv%20In%20Key%20Of%20C.gp5
https://documents.jqguitaracademy.com/Lessons%20-%20Scales%20-%20Caged%20Exercise%202%20-%20Chord%20Progression%20I-V-Vi-Iv%20In%20Key%20Of%20C.gp
https://documents.jqguitaracademy.com/Lessons%20-%20Scales%20-%20Caged%20Exercise%202%20-%20Chord%20Progression%20I-V-Vi-Iv%20In%20Key%20Of%20G.gp
https://documents.jqguitaracademy.com/MajorScales.pdf
https://documents.jqguitaracademy.com/Pentatonic%20Scale%20-%20Exercise%20One.gp
https://documents.jqguitaracademy.com/Simple%20Two-String%20Exercise%20-%20D%20&%20G%20Strings.gp
https://documents.jqguitaracademy.com/Solfege%20Rythmique%20No.%201%20.gp
https://documents.jqguitaracademy.com/Solfege%20Rythmique%20No.%201.pdf




https://documents.jqguitaracademy.com/bass-fretboard-c.pdf

https://documents.jqguitaracademy.com/harmonized-c-maj-d-position.pdf


https://documents.jqguitaracademy.com/legatoexercises.pdf
https://documents.jqguitaracademy.com/major-caged-system-cheatsheet.pdf
https://documents.jqguitaracademy.com/minor-caged-system-cheatsheet.pdf
https://documents.jqguitaracademy.com/notebending-exercise.pdf
https://documents.jqguitaracademy.com/pentatonic-exercises.pdf







*/